import React, { useEffect, useRef } from "react";
import { InjectedContentImage } from "./types/HitProps";

interface InjectedContentProps {
  content: InjectedContentImage;
}

const InjectedContent = ({ content }: InjectedContentProps) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Grid columns are controlled on closest li element
    // Additional info: https://dev.azure.com/distancify/Distancify%20Process/_workitems/edit/24721
    if (contentRef.current) {
      const closestLi = contentRef.current.closest("li");
      if (
        closestLi &&
        closestLi.classList.toString().toLowerCase().includes("ais-hits-item")
      ) {
        closestLi.style.gridColumn = `span ${content.columns}`;
      }
    }
  }, [content.columns]);

  return (
    <div ref={contentRef} className={`product__wrapper`}>
      <div className="injected-content injected-content--image">
        <a href={content.url} className="injected-content__link">
          <img
            src={content.image}
            alt="Campaign Image"
            className="injected-content__image"
            loading="lazy"
          />
        </a>
      </div>
    </div>
  );
};

export default InjectedContent;
